export enum RegionType {
  USOA = 'USOA',
  EMEA = 'EMEA',
  APAC = 'APAC',
  LATM = 'LATM',
}

export enum RegionAbbreviations {
  USOA = 'USOA',
  EMEA = 'EMEA',
  APAC = 'APAC',
  LATM = 'LATM',
}
